import { SNACKBAR } from "../../ActionType/SnackBar";

export const snackBar = (
  snackBar = { open: false, message: "", variant: "success" },
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case SNACKBAR:
      return payload;
    default:
      return snackBar;
  }
};
